import { useTaskTypes } from "@src/data-hooks/task-types/useTaskTypes";
import { translate } from "@src/libs/i18next/translations.util";
import { t } from "i18next";
import { useMemo, useState } from "react";
import { InputElementContext } from "../../../to-be-removed/LocalData/General/DataObjectField/DataObjectField";
import { ModalPopup } from "../ModalPopup/ModalPopup";
import { SelectInputField } from "../SelectInputField/SelectInputField";
import { Text } from "../Text/Text";

interface DataObjectFieldInputProps {
  onFinish: (params: { taskTypeID: string }) => void;
  defaultValue?: string | undefined;
  id: string;
  context?: InputElementContext;
  description?: string;
}

export const DeviationTypeSelectorPopup = (props: DataObjectFieldInputProps) => {
  const [value, setValue] = useState<string>(props.defaultValue ?? "deviation");
  const { taskTypes } = useTaskTypes({ propertyID: props.context?.propertyID });

  const taskTypeOptions = useMemo(() => {
    return taskTypes?.map((taskType) => ({ value: taskType.id, label: translate(taskType.title) })) ?? [];
  }, [taskTypes, taskTypes?.length]);

  return (
    <ModalPopup
      containerProps={{
        maxWidth: "600px",
        style: {
          overflow: "visible",
        },
      }}
      id={props.id}
      disableAction={value === props.defaultValue || value === "routine"}
      title={t("main.editType")}
      actionTitle={t("main.save")}
      onActionClicked={() => {
        props.onFinish({
          taskTypeID: value,
        });
      }}
      children={
        <>
          {props.description && <Text size="sm" text={props.description} />}

          <SelectInputField options={taskTypeOptions} onChange={(selectedOption) => selectedOption && setValue(selectedOption.value)} value={value} />
        </>
      }
    />
  );
};
